import { useEffect, useState } from 'react';
import { InputNumber } from 'tdesign-react';

import { Clock } from '@/components/icon';

import GameTitle from '../title';
import styles from './index.module.less';

interface IProps {
  disabled: boolean;
  value: number;
  show: boolean;
  onChange: (val: number) => void;
}

const CountDown: React.FC<IProps> = (props) => {
  const {
    disabled,
    value,
    show,
    onChange,
  } = props;
  const [count, setCount] = useState(value);

  useEffect(() => {
    setCount(value);
  }, [value]);

  const handleChange = (val: number) => {
    setCount(val);
    onChange(val);
  };

  const formLabel = (title: string, subtitle: string) => (
    <div className={styles.label}>
      <div className={styles.labelTitle}>{title}</div>
      <div className={styles.subTitle}>{subtitle}</div>
    </div>);

  return (
    <div className={styles.wrapper} style={show ? { display: 'flex' } : { display: 'none' }}>
      <GameTitle
        title="倒计时"
        subTitle='倒计时结束前未满足过关条件，则需重玩本幕'
        icon={<Clock />}
        fieldProps='countDown'
      />
      <div className={styles.formItem}>
        {formLabel('倒计时触发', '(最大 99秒)')}
        <InputNumber
          min={0}
          max={99}
          disabled={disabled}
          allowInputOverLimit={false}
          style={{ width: 240 }}
          value={count}
          onChange={v => handleChange(v as number)} />
      </div>
      {count <= 0 || !count ? <div className={styles.errors}>倒计时必须大于0</div> : null}
    </div>
  );
};

export default CountDown;
